import React, { useEffect, useState, useRef } from "react";
import DivisionCmp from "../../components/cards/DivisionCmp";
import { Box } from "@mui/system";
import { Formik, useField } from "formik";
import { Grid } from "@mui/material";
import * as Yup from "yup";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import Button from "@mui/material/Button";
import { HandleNext } from "../../models/sharedFunctions";
import {
  GetCustomerRegistrationInfoRequest,
  GetCustomerRegistrationInfoResponse,
} from "../../models/loan.model";
import {
  NATIONAL_CODE,
  HAS_REGISTER_REQUEST,
  IS_CANCELABLE,
  IS_EDITABLE,
  CUSTOMER_INFO,
  LOAN_TEMPLATE_INFOS,
  EXISTING_LOANREQUEST,
  REFERENCE_KEY,
  Timer_INIT,
  TEXT_DROPDOWN,
} from "../../config/cacheKey";
import { useMutation, useQueryClient } from "react-query";
import CustomerRegistrationInfo from "../../hook";
import { getCustomerRegistrationInfo } from "../../services/loan.service";
import { ApiResultModel } from "../../models/common.model";
import { string } from "yup/lib/locale";



function RegisterNewRequest_({ handleNext }: HandleNext) {
  const [selectedCount, setSelectedPart] = React.useState();
  const [data, setData] = React.useState<GetCustomerRegistrationInfoResponse>();
  const [submitFlag, setSubmitFlag] = React.useState<boolean>(true);
  const yupMax = 10;
  const nationalCodeValid = Yup.object().shape({
    nationalCode: Yup.string()
      .required("کد ملی اجباری می باشد")
      .matches(/^[0-9]+$/, "شماره ملی فقط عدد می باشد")
      .min(yupMax, "شماره ملی ده رقم است")
      .max(yupMax, "شماره ملی فقط ده عدد است"),
  });

  const handleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;

    if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
      event.preventDefault();
    }
    if ((event.target.value.length >= yupMax && key != 8 && key != 46 && selectedCount === 0)) {
      event.preventDefault();
    }
  };


  const currentSelection = (e: any) => {
    setSelectedPart(e.target.value.substring(e.target.selectionStart, e.target.selectionEnd).length);
     }



  const queryClient = useQueryClient();
  useEffect(() => {
    queryClient.setQueryData(HAS_REGISTER_REQUEST, "");
    queryClient.setQueryData(IS_EDITABLE, "");
    queryClient.setQueryData(IS_CANCELABLE, "");
    queryClient.setQueryData(CUSTOMER_INFO, "");
    queryClient.setQueryData(LOAN_TEMPLATE_INFOS, "");
    queryClient.setQueryData(EXISTING_LOANREQUEST, "");
    queryClient.setQueryData(Timer_INIT, false);
  }, []);
  const CustomerRegistrationInfo = useMutation(getCustomerRegistrationInfo, {
    onSuccess: (data: GetCustomerRegistrationInfoResponse) => {
      // queryClient.setQueryData(REFERENCE_KEY, "");
      queryClient.setQueryData(HAS_REGISTER_REQUEST, data.hasRegisterRequest);
      queryClient.setQueryData(IS_EDITABLE, data.isEditable);
      queryClient.setQueryData(IS_CANCELABLE, data.isCancelable);
      queryClient.setQueryData(CUSTOMER_INFO, data.customerInfo);
      queryClient.setQueryData(LOAN_TEMPLATE_INFOS, data.loanTemplateInfos);
      queryClient.setQueryData(EXISTING_LOANREQUEST, data.existingLoanRequest);
      handleNext();
    },
    onError: () => {
      setSubmitFlag(true);
    },
  });

  // let national = new GetCustomerRegistrationInfoRequest();
  // national.nationalCode = queryClient.getQueryData(NATIONAL_CODE);

  // let initialValues={
  //   nationalCode:national.nationalCode
  // }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Formik
        initialValues={new GetCustomerRegistrationInfoRequest()}
        validateOnMount={true}
        validationSchema={nationalCodeValid}
        onSubmit={async (values) => {
          if (submitFlag) {
            setSubmitFlag(false);
            queryClient.setQueryData(NATIONAL_CODE, values.nationalCode);
            
            await CustomerRegistrationInfo.mutateAsync(values);
          }
        }}
      >
        {({
          handleSubmit,
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
        }) => (
          <form onSubmit={handleSubmit} onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSubmit();
            }
          }}>
            <div style={{ paddingRight: "36px", paddingTop: "15px" }}>
              <span style={{ color: "#212121" }}>
                کد ملی متقاضی را وارد کنید:
              </span>

              <Grid container spacing={2} style={{ paddingTop: "30px" }}>
                <Grid
                  item
                  lg={6}
                  xs={6} sm={3} md={6}
                  sx={{ maxWidth: { md: "30% !important" } }}
                >
                  <MaterialTextFieldComponent
                    autoFocus={true}
                    helperText={touched.nationalCode ? errors.nationalCode : ""}
                    error={touched.nationalCode && Boolean(errors.nationalCode)}
                    value={values.nationalCode}
                    placeHolder={"*کد ملی "}
                    label={"*کد ملی "}
                    required={true}
                    name="nationalCode"
                    id="nationalCode"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onKeyDown={handleKeyDown}
                    onSelect={currentSelection}
                  />
                </Grid>

                <Grid item xs={3} sm={2} md={1}>
                  {/* <Button className="btnForm primaryDefault  marginRight-12 " type="submit" style={{color: !isValid? "#e6123d":  "#28a745"}} disabled={!isValid} >تایید و ادامه</Button> */}
                  <Button
                    type="submit"
                    disabled={Object.keys(errors).length > 0 && submitFlag}
                    className={`${Object.keys(errors).length > 0
                      ? "btnForm disabledBtn  "
                      : "btnForm SuccessDefault  "
                      }`}
                    style={{ width: "120px",marginRight:"1vh"}
                  }
                  >
                    تایید و ادامه
                  </Button>
                </Grid>
                <Grid item xs={5} sm={7} md={7}></Grid>
              </Grid>
            </div>
          </form>
        )}
      </Formik>
    </Box>
  );
}

export default function RegisterNewRequest({ handleNext }: HandleNext) {
  const child = <RegisterNewRequest_ handleNext={handleNext} />;
  return <DivisionCmp child={child} title="ثبت کد ملی متقاضی"></DivisionCmp>;
}
